import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement, NgElementConfig } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApiService } from './services/api.service';
import { UtilsService } from './services/utils.service';
import { CrossService } from '@robisoft/cross-library';
import { LuxonModule } from 'luxon-angular';

// cross-utils
import { CrossCpService } from './cross-utils/services/cross-cp.service';
import { CrossContactsService } from './cross-utils/services/cross-contacts.service';
import { ErrorMessageComponent } from './cross-utils/error-message/error-message.component';
import { ConfirmComponent } from './cross-utils/confirm/confirm.component';
import { DatePickerComponent } from './cross-utils/date-picker/date-picker.component';
import { GetNameMultilangComponent } from './cross-utils/get-name-multilang/get-name-multilang.component';
import { LangInputComponent } from './cross-utils/input-lang/input-lang.component';
import { InputNumberComponent } from './cross-utils/input-number/input-number.component';

// opengolf


// material
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCommonModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop'; 
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatButtonModule } from '@angular/material/button'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatIconModule } from '@angular/material/icon'; 
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input'; 
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RicercaGolfclubComponent } from './opengolf/ricerca-golfclub/ricerca-golfclub.component';
import { PacchettiGolfComponent } from './opengolf/pacchetti-golf/pacchetti-golf.component';
import { PrenotaTeetimeComponent } from './opengolf/prenota-teetime/prenota-teetime.component';
import { PrenotazioniTeetimeComponent } from './opengolf/prenotazioni-teetime/prenotazioni-teetime.component';
import { RichiediInfoComponent } from './opengolf/richiedi-info/richiedi-info.component';
import { RichiestaSocioGolfComponent } from './opengolf/richiesta-socio-golf/richiesta-socio-golf.component';
import { TorneiGolfComponent } from './opengolf/tornei-golf/tornei-golf.component';
import { GalleryHotelComponent } from './dialogs/gallery-hotel/gallery-hotel.component';
import { SafeHtmlPipe } from './opengolf/pipes/html-format.pipe';
import { RicercaPacchettiGolfComponent } from './opengolf/ricerca-pacchetti-golf/ricerca-pacchetti-golf.component';
import { BiglietteriaComponent } from './dialogs/biglietteria/biglietteria.component';

@NgModule({
  declarations: [
    // cross-utils
    ErrorMessageComponent,
    ConfirmComponent,
    DatePickerComponent,
    GetNameMultilangComponent,
    LangInputComponent,
    InputNumberComponent,
    SafeHtmlPipe,
    // dialogs

    // components
    RicercaGolfclubComponent,
    PacchettiGolfComponent,
    RicercaPacchettiGolfComponent,
    PrenotaTeetimeComponent,
    PrenotazioniTeetimeComponent,
    RichiediInfoComponent,
    RichiestaSocioGolfComponent,
    TorneiGolfComponent,
    GalleryHotelComponent,
    BiglietteriaComponent,
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    MatButtonModule,
    MatCheckboxModule,
    MatCommonModule,
    MatDialogModule,
    DragDropModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTabsModule,
    MatTableModule,
    MatSelectModule,
    LuxonModule,
    GoogleMapsModule,
    RecaptchaModule
  ],
  providers: [
    ApiService,
    UtilsService,
    CrossService,
    SafeHtmlPipe,
    
    // cross-utils
    CrossCpService,
    CrossContactsService
  ],
  /* bootstrap: [AppComponent], */
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  
  entryComponents: [
//    SearchBdtProgettiComponent,
    AppComponent
  ]
})
export class AppModule implements DoBootstrap { 
  constructor(private injector: Injector) {
  }
  ngDoBootstrap() {
    
    if (!customElements.get('plugin-opengolf')) {
      const plugin = createCustomElement(AppComponent, { injector: this.injector });
      customElements.define('plugin-opengolf', plugin);
    }

  }
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  const VERS = '1';
return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + VERS); // carica quello crossWeb
}
